import React from "react";
import { Input } from "../../shadcn/input";
import { cn } from "../../shadcn/lib/utils";

const CustomInput = ({
  label,
  type,
  placeholder,
  value,
  onChange,
  name,
  error,
  errorText,
  disabled,
  bottomActionText,
  bottomActionClick,
  customButton,
  inputRef,
  customButtonStyle,
  readOnly,
  className,
  wrapperClassName,
  wrapperStyle,
  labelClassName,
}) => {
  const isEmailType = type === "email";
  const hasRightButton = Boolean(customButton);
  return (
    <div className={cn("flex flex-col gap-1.5 w-full", wrapperClassName)} style={wrapperStyle}>
      {label && (
        <label
          htmlFor={name}
          className={cn("font-inter text-sm font-medium leading-5", labelClassName)}
          style={{ color: "#414651" }}
        >
          {label}
        </label>
      )}

      <div className="relative flex items-center w-full">
        {isEmailType && (
          <span
            aria-hidden
            className="pointer-events-none absolute left-[14px] top-1/2 -translate-y-1/2 inline-flex items-center justify-center"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.3333 4.99967C18.3333 4.08301 17.5833 3.33301 16.6667 3.33301H3.33334C2.41667 3.33301 1.66667 4.08301 1.66667 4.99967M18.3333 4.99967V14.9997C18.3333 15.9163 17.5833 16.6663 16.6667 16.6663H3.33334C2.41667 16.6663 1.66667 15.9163 1.66667 14.9997V4.99967M18.3333 4.99967L10 10.833L1.66667 4.99967"
                stroke="#717680"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
        <Input
          ref={inputRef}
          readOnly={readOnly}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          id={name}
          disabled={disabled}
          className={cn(
            "placeholder:text-gray-400",
            isEmailType && "pl-[42px]",
            hasRightButton && "pr-[42px]",
            readOnly && "cursor-not-allowed",
            className
          )}
        />

        {customButton && (
          <div
            className={cn(
              "absolute right-[14px] top-1/2 -translate-y-1/2 inline-flex items-center justify-center",
            )}
            style={customButtonStyle}
          >
            {customButton}
          </div>
        )}
      </div>

      {bottomActionText && (
        <p
          className="text-sm font-bold leading-5 text-blue-600 cursor-pointer ml-auto"
          onClick={bottomActionClick}
        >
          {bottomActionText}
        </p>
      )}

      {error && (
        <p className="text-base font-bold leading-6 text-red-500">
          {errorText}
        </p>
      )}
    </div>
  );
};

export default CustomInput;
